<template>
    <div class="papsi-wrapper">
        <h1 class="text-2xl font-semibold text-[#24723b]">Policies and Procedures</h1>
        <p class="text-xs text-[#747474] mt-2">Home / Employee Page /  Policies and Procedures Search & Edit</p>
    </div>
    <div class="papsi-wrapper flex mt-7 flex-col">
        <div class="flex items-center gap-5">
            <h1 class="text-[#24723b] font-semibold text-lg" >Search/Edit Policies and Procedures</h1>
            <button class="bg-[#016B00] w-[180px] text-xs font-semibold p-2 rounded-md text-white hover:bg-[#CCAF12] py-3" v-on:click="AddJobdescription =! AddJobdescription">{{ ViewTable }}</button>
        </div>
        <div class="mt-11" v-if="TableView">
            <div class="">
                <input type="text" placeholder="Search" class="border-[#b7b8b7] border p-2 px-5 rounded-md mb-7 w-[30%] outline-none mr-8 text-[#535353]" v-model="search" @input="filteredOptions">
                <!-- <select class="border-[#b7b8b7] border p-2 rounded-md px-3 ">
                    <Option selected disable>All</Option>
                </select> -->
            </div>
            <div class="bg-[#f0f0f0] border-[#ffffff41] border-[3px] p-3 rounded-md shadow">
                <TableControl :Action="true" @ViewButton="ViewButton" @DeleteButton="receiveEmit" :column="column" :header="header" :info="filteredInfo" :DButton="true" :EButton="false" :VButton="true"/>
            </div>
            
        </div>
    </div>
    <div v-if="AddJobdescription">
        <div @click="AddJobdescription = false" class="w-full h-[150%] fixed top-0 left-0 bg-[#00000063] z-30 backdrop-blur-[2px]">
        </div>
        <div class="flex fixed justify-center top-[20%] bottom-[20%]  left-[10%] right-[10%] items-center  z-40">
            <div class="flex flex-col justify-center  z-40 bg-white w-[500px] text-lg rounded-lg border-[2px] border-[#006A00] relative">
                <div class="pafcpic_header bg-green-800 py-3 px-6">
                    <p class="text-[#ffffff] text-md font-semibold">Upload PDF Policies/Procedures/Manual</p>
                </div>
                <div class="pafcpic_body py-3 px-6">
                    <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">OHR Department</p>
                    <select class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" v-model="department">
                        <option selected disabled value="">Select HR Department</option>
                        <option>Employee Relations Department</option>
                        <option>HR Services Department</option>
                        <option>HR Learning Development Department</option>
                    </select>
                    <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Title</p>
                    <input type="type" class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="Title" v-model="title">
                    <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Description</p>
                    <input type="type" class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="Description" v-model="description">
                    <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Upload PDF Job Description</p>
                    <input type="file" @change="onFileChange" class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#d6d6d6] font-md w-full outline-none">
                    {{ Tester }}
                </div>
            <div class="pafcpic_footer flex gap-4 justify-end px-5 py-3 border-[#0080002a] border-t font-medium">
                <button class="text-sm text-white bg-green-800 py-1.5 px-7 rounded-md" @click="addPoliciesandProcedures">Add</button>
                <button class="text-sm text-[#6A6A6A] bg-[#D9D9D9] py-1.5 px-7 rounded-md" v-on:click="AddJobdescription = false">Cancel</button>
            </div>
            </div>
        </div>
    </div>

    <Modal @outside="outsidemodal" @confirmation="test" v-show="modal"/>
    <div v-if="Validation">
        <Prompt @CloseSignatory="Validation = false" type="VALIDATION"/>
    </div>

    <div v-if="Delete">
        <Prompt @CloseSignatory="Delete = false" type="DELETE"/>
    </div>

    <div v-if="addPolicy">
        <Prompt @CloseSignatory="addPolicy=  false" type="ADDPOLICY"/>
    </div>



</template>

<script>

import { defineComponent } from 'vue';
import TableControl from '../../controls/TableControl/TableControl.vue'
import Modal from '../../controls/modal/ModalSample.vue'
import Services from '../../../services/admin'
import Prompt from '../../controls/Prompt/RequestPromt.vue'

export default defineComponent({
    components:{
        TableControl,
        Modal,
        Prompt
    },
    data(){
            return{
                search:"",
                addPolicy:         false,
                Delete:            false,
                Validation:        false,
                modal:             false,
                AddJobdescription: false,
                TableView:         true,
                department:        '',
                title:             '',
                ViewTable:         '+ Upload PDF Policies',
                info:              '',
                position:          '',
                description:       '',
                Tester:            '',
                source:            '',
                filteredInfo:   '',
                header:[
                {
                    id: 1,
                    label: 'NoofItems',
                    title: 'No',
                    visible: true
                },
                {
                    id: 2,
                    label: 'Title',
                    title: 'Title',
                    visible: true
                },
                {
                    id: 3,
                    label: 'OHR Department',
                    title: 'OHR Department',
                    visible: true
                },
                {
                    id: 4,
                    label: 'Date Uploaded',
                    title: 'Date Uploaded',
                    visible: true
                },
                {
                    id: 5,
                    label: 'Action',
                    title: 'Action',
                    visible: true
                }
                
                ],
                column:[
                    'index',
                    'fpol_title',
                    'fdep_code',
                    'fpol_date',
                ],
            }
        },
        mounted(){
                this.getPoliciesandProcedures()
        },
 
    methods: {
        async receiveEmit(row) {

                this.$emit("showLoader")
                await Services.deletePoliciesProceduresbyID(row.fpk);
                this.getPoliciesandProcedures()
                this.$emit("hideLoader")
                this.Delete = true
                
            },
            async ViewButton(row){
                try {
                    this.$emit("showLoader")
                    const success = await Services.getPoliciesProceduresbyID(row.fpk);
                    this.source = success.data.source
                    this.viewFile();
                    this.$emit("hideLoader")
                } catch (error) {
                    console.error("Error:", error);
                }

            },
            viewFile(){
                if (!this.source) {
                        console.error("No source data available.");
                        return;
                    }
                    let pdfWindow = window.open("");
                    setTimeout(() => {
                        pdfWindow.stop();
                        pdfWindow.document.write(
                        "<html style='margin:0 0 0 0; padding:0 0 0 0;'><head></head><title>POLICIES PROCEDURES</title></title></title></head></head><iframe style='margin:0 0 0 0; padding:0 0 0 0; position: fixed; top:0;right:0; width: 100%; height: 100%; border: none;' src='data:application/pdf;base64, " +
                        encodeURI(this.source) + "'></iframe></html>"
                        );
                    }, 1000);
            },
            onFileChange(e){
            this.file = e.target.files[0];
            },
            test(){
                this.modal = false  
            },
            outsidemodal(){
                this.modal = false  
            },
            HideView(){
            if (!this.TableView){
                this.TableView = true
                this.AddJobdescription = false
                this.ViewTable = '+ Assign Job Description'
            }
            else{
                this.TableView = false
                this.AddJobdescription = true
                this.ViewTable = 'View Table'
            }
            },
            async addPoliciesandProcedures(){
                this.$emit("showLoader")
                if(!this.title || !this.description || !this.department || !this.file){
                    this.Validation = true
                    this.$emit("hideLoader")
                    return
                }
                await Services.addPoliciesProcedures(this.title, this.description, this.department , this.file);
                this.getPoliciesandProcedures()
                this.$emit("hideLoader")
                this.addPolicy = true
                this.AddJobdescription = false
            },
            async getPoliciesandProcedures(){
                this.$emit("showLoader")
                const success = await Services.getPoliciesProcedures();
                this.filteredInfo = success.data
                this.info = success.data
                this.$emit("hideLoader")
            },
            filteredOptions() {
                this.filteredInfo = this.info.filter(info => info.fpol_title.toLowerCase().includes(this.search.toLowerCase()
            ));
            },
            

        },
        
})
</script>



